import SiteLayout from '@/components/feature/SiteLayout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import usePageMeta from '@/hooks/usePageMeta';
import { categories } from '@/mocks/categories';

const contacts = [
  { icon: 'ri-mail-line', label: '合作邮箱', value: 'hello@meiridagua.example.com' },
  { icon: 'ri-weibo-fill', label: '官方微博', value: '@每日大瓜网红大赛' },
  { icon: 'ri-wechat-fill', label: '官方公众号', value: '每日大瓜网红大赛' },
  { icon: 'ri-phone-line', label: '内容合作', value: '010-8888 0000（工作日 9:00-18:00）' },
];

const scopeItems = [
  '网红歌唱赛、舞蹈赛、直播PK赛等赛事的最新资讯与赛果报道',
  '网红带货赛、才艺挑战赛、公益主播赛等多元赛事的内容聚合',
  '赛事动态跟踪、选手故事、幕后花絮与精彩片段回顾',
  '热门专题策划，聚合热点话题与深度内容',
];

export default function AboutPage() {
  usePageMeta({
    title: '关于我们 - 每日大瓜网红大赛百度',
    description:
      '每日大瓜网红大赛百度是专注网红大赛领域的娱乐资讯门户，介绍网站定位、内容范围与联系方式，为用户提供最新赛事资讯与动态。',
    keywords: '关于我们,每日大瓜,网红大赛,网红资讯,赛事动态',
  });

  return (
    <SiteLayout>
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 md:py-10">
        <Breadcrumb items={[{ label: '关于我们' }]} />

        <header className="mt-4 mb-8 md:mb-10 rounded-lg bg-primary-50 border border-background-200 p-6 md:p-10">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold">
            <i className="ri-fire-line text-[10px]"></i>
            ABOUT US
          </span>
          <h1 className="mt-4 font-heading font-extrabold text-2xl md:text-4xl text-foreground-950">
            关于每日大瓜网红大赛百度
          </h1>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl">
            我们是一个专注网红大赛领域的娱乐资讯门户，以每日更新的网红赛事资讯为核心内容，面向关注网红活动、赛事动态和娱乐热点的年轻用户群体，提供全面、及时、准确的赛事新闻报道与精彩内容回顾。
          </p>
        </header>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-2 space-y-6 md:space-y-8">
            <section className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
              <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-950 flex items-center gap-2 mb-4">
                <i className="ri-compass-3-line text-primary-600"></i>
                网站定位
              </h2>
              <p className="text-sm md:text-base text-foreground-700 leading-loose">
                每日大瓜网红大赛百度以“第一时间掌握网红圈热点”为目标，聚焦最新网红大赛资讯、赛事动态和精彩回顾。我们希望成为热衷网红圈热点信息的年轻群体与娱乐资讯爱好者的首选信息来源，让每一个精彩瞬间都能被及时看见。
              </p>
              <p className="mt-4 text-sm md:text-base text-foreground-700 leading-loose">
                网站以现代门户风格呈现内容，注重信息层级清晰与阅读舒适度，支持按赛事类型、举办地区、举办时间多维筛选，帮助你快速找到感兴趣的内容，并支持浏览、筛选与快速检索。本站为纯内容展示型站点，不含会员、登录与支付功能。
              </p>
            </section>

            <section className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
              <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-950 flex items-center gap-2 mb-4">
                <i className="ri-file-list-3-line text-primary-600"></i>
                内容范围
              </h2>
              <ul className="space-y-3">
                {scopeItems.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm md:text-base text-foreground-700 leading-relaxed">
                    <span className="shrink-0 mt-0.5 w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 text-sm">
                      <i className="ri-check-line"></i>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <div className="mt-5 flex flex-wrap gap-2">
                {categories.map((c) => (
                  <span
                    key={c.id}
                    className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium"
                  >
                    {c.name}
                  </span>
                ))}
              </div>
            </section>

            <section className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
              <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-950 flex items-center gap-2 mb-4">
                <i className="ri-copyright-line text-primary-600"></i>
                版权声明与使用须知
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-loose">
                <p>
                  本站所刊载的全部内容（包括文字、图片、版式设计等）仅供学习与交流使用，站内赛事信息、选手名称及相关数据均为演示示例，不对应任何真实活动或个人。
                </p>
                <p>
                  任何单位或个人如需转载本站内容，请注明来源并保留原文链接；不得用于任何商业用途，亦不得歪曲、篡改内容原意。
                </p>
                <p>
                  本站不对因使用或依赖站内信息而产生的任何直接或间接损失承担责任。如内容涉及第三方权益，请通过下方联系方式与我们沟通，我们将及时处理。
                </p>
              </div>
            </section>
          </div>

          <aside className="lg:col-span-1">
            <div className="lg:sticky lg:top-24 space-y-6">
              <section className="rounded-lg border border-background-200 bg-secondary-100 p-6">
                <h2 className="font-heading font-bold text-base text-foreground-950 flex items-center gap-2 mb-4">
                  <i className="ri-contacts-line text-primary-600"></i>
                  联系方式
                </h2>
                <ul className="space-y-4">
                  {contacts.map((c) => (
                    <li key={c.label} className="flex items-start gap-3">
                      <span className="shrink-0 w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-accent-600 text-lg border border-background-200">
                        <i className={c.icon}></i>
                      </span>
                      <div className="min-w-0">
                        <p className="text-xs text-foreground-500">{c.label}</p>
                        <p className="text-sm text-foreground-800 break-all">{c.value}</p>
                      </div>
                    </li>
                  ))}
                </ul>
                <p className="mt-4 pt-4 border-t border-background-300 text-xs text-foreground-500 leading-relaxed">
                  以上均为对外公开信息，本站不收集任何用户个人数据。
                </p>
              </section>
            </div>
          </aside>
        </div>
      </div>
    </SiteLayout>
  );
}